import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-service-role-detail',
  templateUrl: './service-role-detail.component.html',
  styleUrls: ['./service-role-detail.component.scss']
})
export class ServiceRoleDetailComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
